import { render, staticRenderFns } from "./paperBtn.vue?vue&type=template&id=44634708&scoped=true&"
import script from "./paperBtn.vue?vue&type=script&lang=js&"
export * from "./paperBtn.vue?vue&type=script&lang=js&"
import style0 from "./paperBtn.vue?vue&type=style&index=0&id=44634708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44634708",
  null
  
)

export default component.exports